var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SafeAnchor } from '../SafeAnchor';
import { useTranslationContext } from '../../context/TranslationContext';
import { useChannelStateContext } from '../../context/ChannelStateContext';
var UnMemoizedCard = function (props) {
    var giphy = props.giphy, image_url = props.image_url, og_scrape_url = props.og_scrape_url, text = props.text, thumb_url = props.thumb_url, title = props.title, title_link = props.title_link, type = props.type;
    var t = useTranslationContext('Card').t;
    var giphyVersionName = useChannelStateContext('Card').giphyVersion;
    var image = thumb_url || image_url;
    var dimensions = {};
    if (type === 'giphy' && typeof giphy !== 'undefined') {
        var giphyVersion = giphy[giphyVersionName];
        image = giphyVersion.url;
        dimensions.height = giphyVersion.height;
        dimensions.width = giphyVersion.width;
    }
    var trimUrl = function (url) {
        if (url !== undefined && url !== null) {
            var trimmedUrl = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
            return trimmedUrl;
        }
        return null;
    };
    if (!title && !title_link && !image) {
        return (React.createElement("div", { className: "str-chat__message-attachment-card str-chat__message-attachment-card--" + type },
            React.createElement("div", { className: 'str-chat__message-attachment-card--content' },
                React.createElement("div", { className: 'str-chat__message-attachment-card--text' }, t('this content could not be displayed')))));
    }
    if (!title_link && !og_scrape_url) {
        return null;
    }
    return (React.createElement("div", { className: "str-chat__message-attachment-card str-chat__message-attachment-card--" + type },
        image && (React.createElement("div", { className: 'str-chat__message-attachment-card--header' },
            React.createElement("img", __assign({ alt: image, src: image }, dimensions)))),
        React.createElement("div", { className: 'str-chat__message-attachment-card--content' },
            React.createElement("div", { className: 'str-chat__message-attachment-card--flex' },
                title && React.createElement("div", { className: 'str-chat__message-attachment-card--title' }, title),
                text && React.createElement("div", { className: 'str-chat__message-attachment-card--text' }, text),
                (title_link || og_scrape_url) && (React.createElement(SafeAnchor, { className: 'str-chat__message-attachment-card--url', href: title_link || og_scrape_url, rel: 'noopener noreferrer', target: '_blank' }, trimUrl(title_link || og_scrape_url)))))));
};
/**
 * Simple Card Layout for displaying links
 */
export var Card = React.memo(UnMemoizedCard);
